module.exports = __webpack_public_path__ + "assets/img/Pioneer_Chassard_003.6e55589d-ps.jpg";